export default __webpack_public_path__ + "static/media/slide03.f4cb29ea.jpg";